import classNames from "classnames";
import {getAvailabilityStatus} from "../../model/availability";
import styles from "./ProductAvailability.module.scss";

type Props = {
    count: number;
};

export const ProductAvailability = ({count}: Props) => {
    const status = getAvailabilityStatus(count);

    const text = {
        outOfStock: "Нет в наличии",
        lowStock: `В наличии всего ${count}`,
        inStock: "В наличии",
    }[status];

    return (
        <p className={classNames(styles.availability, styles[status])}>
            {text}
        </p>
    );
};
